export default __webpack_public_path__ + "static/media/telegram.d65a9cbe.svg";